import clonedeep from 'lodash.clonedeep';
import {
  validationSearchParams,
  createSortColumns,
  saveLocalStorage,
  loadLocalStorage,
  getFlatTags,
  getEnableTags,
} from '../lib/tools';
import config from '../config/index';
import { TAGS_DIALOG_SELECT_TAB } from '../lib/constants';
import * as types from '../actions/actionTypes';
import { ActionTypes as Type } from '../actions/timeline';

const searchCriteria = config.localStorageKey.timeline;

const appInitialState = {
  timelines: [],
  totalNumber: 0,
  totalPages: 0,
  searchOptions: {
    numberPerPage: 100,
    page: 1,
    sortColumns: [
      {
        column: 'recordedDate',
        order: 'D',
      },
    ],
    recordedDateFrom: '',
    recordedDateTo: '',
    partialOperatorName: '',
    partialDeviceNickname: '',
    tags: {
      depth: null,
      tagId: null,
    },
    isSearchForUnsetTagOnly: false,
    mediaTypes: [],
    freeTag: '',
    groupIds: [],
    isDeleted: false,
  },
  searchOptionsError: {
    recordedDateFrom: false,
    recordedDateTo: false,
  },
  selectOptions: {
    maxDepth: 5,
    tags: {},
    ids: {}, // TODO 階層1がnullになっている。未使用？
  },
  currentPage: 1,
  downloading: false,
  checkbox: {
    ids: [],
  },
  refreshPage: false,
  selectedTagIds: [],
  executeEvent: '',
  editOptions: {
    maxDepth: 5,
    freeTag: null,
    tags: {},
    ids: {},
  },
  openUpdateTagsDialog: false,
  canLoadSearchCriteria: false,
  selectedTab: TAGS_DIALOG_SELECT_TAB.update,
  clearCheckbox: {
    freeTag: false,
    masterTag: false,
  },
  flatTags: [],
  tagsForSearch: [],
};

export default (state = appInitialState, action) => {
  switch (action.type) {
    case 'LOGOUT': {
      saveLocalStorage(searchCriteria.selectedGroupIds, null);
      return state;
    }
    case 'COMPANY_CHANGED': {
      saveLocalStorage(searchCriteria.selectedGroupIds, null);
      const { searchOptions, selectedTagIds } = state;
      return { ...appInitialState, searchOptions, selectedTagIds };
    }
    case 'LOAD_SEARCH_CRITERIA': {
      // APP起動時にタイムライン検索条件を読み込む
      const data = {
        recordedDateFrom: loadLocalStorage(searchCriteria.recordedDateFrom),
        recordedDateTo: loadLocalStorage(searchCriteria.recordedDateTo),
        partialOperatorName: loadLocalStorage(
          searchCriteria.partialOperatorName,
        ),
        partialDeviceNickname: loadLocalStorage(
          searchCriteria.partialDeviceNickname,
        ),
        freeTag: loadLocalStorage(searchCriteria.freeTag),
        tags: loadLocalStorage(searchCriteria.tags),
        selectedTagIds: loadLocalStorage(searchCriteria.selectedTagIds),
        isSearchForUnsetTagOnly: loadLocalStorage(
          searchCriteria.isSearchForUnsetTagOnly,
        ),
        groupIds: loadLocalStorage(searchCriteria.selectedGroupIds),
      };
      const searchOptions = {
        ...state.searchOptions,
        recordedDateFrom:
          (data.recordedDateFrom && data.recordedDateFrom) ||
          state.searchOptions.recordedDateFrom,
        recordedDateTo:
          (data.recordedDateTo && data.recordedDateTo) ||
          state.searchOptions.recordedDateTo,
        partialOperatorName:
          (data.partialOperatorName &&
            decodeURIComponent(data.partialOperatorName)) ||
          state.searchOptions.partialOperatorName,
        partialDeviceNickname:
          (data.partialDeviceNickname &&
            decodeURIComponent(data.partialDeviceNickname)) ||
          state.searchOptions.partialDeviceNickname,
        freeTag:
          (data.freeTag && decodeURIComponent(data.freeTag)) ||
          state.searchOptions.freeTag,
        tags: (data.tags && JSON.parse(data.tags)) || state.searchOptions.tags,
        isSearchForUnsetTagOnly:
          (data.isSearchForUnsetTagOnly && data.isSearchForUnsetTagOnly) ||
          state.searchOptions.isSearchForUnsetTagOnly,
        groupIds:
          (data.groupIds && JSON.parse(data.groupIds)) ||
          state.searchOptions.groupIds,
      };
      const selectedTagIds =
        (data.selectedTagIds && JSON.parse(data.selectedTagIds)) ||
        state.selectedTagIds;
      return {
        ...state,
        searchOptions,
        selectedTagIds,
        canLoadSearchCriteria: true,
      };
    }
    case 'FINISH_LOAD_SEARCH_CRITERIA': {
      const { canLoadSearchCriteria } = appInitialState;
      return { ...state, canLoadSearchCriteria };
    }
    case 'SUCCESS_API_GET_WORK_RECORDS': {
      const payload = action.payload || {};
      return { ...state, ...payload };
    }
    case 'PAGENATION_SELECT_PAGE': {
      const page = (action && action.page) || 1;
      const searchOptions = { ...state.searchOptions, page };
      return { ...state, searchOptions };
    }
    case 'TIMELINELISTS_CHANGE_SORT': {
      const column = (action && action.sortColumn) || 'recordedDate';
      const firstSort = (column === 'workerName' && 'A') || 'D';
      const oldSortcolumns = state.searchOptions.sortColumns;
      const sortColumns = createSortColumns(oldSortcolumns, column, firstSort);
      const searchOptions = {
        ...state.searchOptions,
        page: appInitialState.searchOptions.page,
        sortColumns,
      };
      const checkbox = { ...appInitialState.checkbox };
      return { ...state, searchOptions, checkbox };
    }
    case 'SEARCHBOX_UPDATE_SEARCH_OPTIONS': {
      const { option: params } = action;
      const optionError = validationSearchParams(params);
      const searchOptionsError = {
        ...state.searchOptionsError,
        ...optionError,
      };
      const checkbox = { ...appInitialState.checkbox };
      const key = Object.keys(params)[0];
      const searchOptions = { ...state.searchOptions, ...params, page: 1 };

      // 更新した検索条件がtags以外の場合はそのままsearchOptionをstateに反映する
      if (key !== 'tags') {
        return { ...state, searchOptions, searchOptionsError, checkbox };
      }

      // tagsの場合は編集が必要
      const value = Object.values(params)[0];
      const { depth, tagId } = value;
      const currentDepth = state.searchOptions.tags.depth;
      const selectedTagIds = state.selectedTagIds.slice();
      // 現在の階層の次階層を指定した場合は設定値をstateに反映する
      if (currentDepth < depth) {
        selectedTagIds.splice(depth - 1, 1, tagId);
        return {
          ...state,
          searchOptions,
          selectedTagIds,
          searchOptionsError,
          checkbox,
        };
      }

      // 現在の階層もしくは上位の階層を指定した場合は全体もしくは一部の初期化処理が必要
      let tags;
      if (tagId === -1) {
        // 現在の選択タグ情報を1つ上の階層値に設定
        tags = {
          depth: depth === 1 ? null : depth - 1,
          tagId: depth === 1 ? null : selectedTagIds[depth - 2],
        };
        // 値がnullの階層から初期化する
        selectedTagIds.splice(depth - 1);
      } else {
        // 値がnull以外の場合は
        tags = { depth, tagId };
        // 選択した階層以降の選択値を初期化し、また選択値を反映
        selectedTagIds.splice(depth);
        selectedTagIds.splice(depth - 1, 1, tagId);
      }
      // 値を返却
      return {
        ...state,
        searchOptions: { ...searchOptions, tags },
        selectedTagIds,
        searchOptionsError,
        checkbox,
      };
    }
    case 'SEARCHBOX_UPDATE_SEARCH_TAGS': {
      const { params } = action;
      const searchOptions = {
        ...state.searchOptions,
        tags: params[params.length - 1],
        page: 1,
      };
      const selectedTagIds = params.map(({ tagId }) => tagId);
      const tags = getEnableTags(state.tagsForSearch, params);
      const selectOptions = {
        maxDepth: 5,
        tags,
        ids: {}, // 未使用なので設定しない
      };
      return {
        ...state,
        searchOptions,
        selectedTagIds,
        checkbox: appInitialState.checkbox,
        selectOptions,
        flatTags: appInitialState.flatTags,
        tagsForSearch: appInitialState.tagsForSearch,
      };
    }
    case 'SEARCHBOX_RESET_SEARCH_OPTIONS': {
      const { timelines, checkbox, executeEvent } = appInitialState;
      const { refreshPage } = state;
      return {
        ...state,
        timelines,
        checkbox,
        refreshPage: !refreshPage,
        executeEvent,
      };
    }
    case Type.SUCCESS_API_DELETE_WORK_RECORDS: {
      const checkbox = { ...appInitialState.checkbox };
      const searchOptions = { ...state.searchOptions, page: 1 };
      return { ...state, checkbox, searchOptions };
    }
    case 'TIMELINESEARCHBOX_CHECKBOX_CHECK': {
      const searchOptions = {
        ...state.searchOptions,
        isSearchForUnsetTagOnly: action.checked,
      };
      return { ...state, searchOptions };
    }
    case 'TIMELINELISTS_CHECKBOX_CHECK': {
      const checkedHeader = action.value === 'all';
      const targetIds = checkedHeader
        ? state.timelines.map(timeline => timeline.id)
        : [Number(action.value)];
      const ids = action.checked
        ? state.checkbox.ids
            .concat(targetIds)
            .filter((x, i, self) => self.indexOf(x) === i)
        : state.checkbox.ids.filter(x => targetIds.indexOf(x) === -1);
      return { ...state, checkbox: { ids } };
    }
    case 'SUCCESS_API_GET_TAGS': {
      const tags = action && action.payload.tags;
      if (tags.length <= 0) {
        return { ...state };
      }
      const { isEdit } = action;
      const { selectOptions, editOptions } = clonedeep(state);
      const workOptions = isEdit ? editOptions : selectOptions;
      const { depth, parentId } = action.searchOptions;
      workOptions.maxDepth = action && action.payload.maxDepth;
      for (let i = depth; i <= workOptions.maxDepth; i += 1) {
        delete workOptions.tags[i];
        if (!isEdit) {
          delete workOptions.ids[i];
        }
      }
      workOptions.tags[depth] = tags[0].data;
      if (!isEdit) {
        workOptions.ids[depth] = parentId;
      }
      return isEdit
        ? { ...state, editOptions: workOptions }
        : { ...state, selectOptions: workOptions };
    }
    case 'UPDATE_EXECUTE_EVENT': {
      const executeEvent =
        (action && action.executeEvent) || appInitialState.executeEvent;
      return { ...state, executeEvent };
    }
    case 'OPEN_UPDATE_TAGS_DIALOG': {
      return { ...state, openUpdateTagsDialog: true };
    }
    case 'CLOSE_UPDATE_TAGS_DIALOG': {
      const clearCheckbox = { ...appInitialState.clearCheckbox };
      return {
        ...state,
        editOptions: { ...state.editOptions, ids: {} },
        clearCheckbox,
        openUpdateTagsDialog: false,
        selectedTab: TAGS_DIALOG_SELECT_TAB.update,
      };
    }
    case types.SUCCESS_UPDATE_WROKRECORD_TAG: {
      return { ...state, checkbox: appInitialState.checkbox };
    }
    case 'UPDATE_FREE_TAG': {
      // タグ編輯ダイアログの自由タグ情報を更新
      const editOptions = clonedeep(state.editOptions);
      editOptions.freeTag = action && action.freeTag;
      return { ...state, editOptions };
    }
    // ログイン時のみ実行される
    case 'UPDATE_SELECT_OPTIONS_TAGS': {
      const { tags, maxDepth } = action.payload;
      const selectOptions = clonedeep(state.selectOptions);
      const newTags = {};
      tags.forEach((value, index) => {
        newTags[index + 1] = value.data;
      });
      selectOptions.tags = newTags;
      selectOptions.maxDepth = maxDepth;
      return { ...state, selectOptions };
    }
    case 'UPDATE_EDIT_TAGS': {
      // タグ編集ダイアログの選択可能なタグ情報を更新
      const editOptions = clonedeep(state.editOptions);
      const { tags, maxDepth } = action.payload;
      const newTags = {};
      tags.forEach((value, index) => {
        newTags[index + 1] = value.data;
      });
      editOptions.tags = newTags;
      editOptions.maxDepth = maxDepth;
      return { ...state, editOptions };
    }
    case 'UPDATE_EDIT_IDS': {
      // タグ編集ダイアログの選択タグID情報（複数）を更新
      const editOptions = clonedeep(state.editOptions);
      const { ids } = action;
      const newIds = {};
      ids.forEach((value, index) => {
        newIds[index + 1] = value;
      });
      editOptions.ids = newIds;
      return { ...state, editOptions };
    }
    case 'UPDATE_TAG_ID': {
      // タグ編集ダイアログの選択タグID情報（単体）を更新
      const editOptions = clonedeep(state.editOptions);
      const { depth, id } = action;
      for (let i = depth; i <= editOptions.maxDepth; i += 1) {
        delete editOptions.ids[i];
      }
      if (id >= 0) {
        editOptions.ids[depth] = id;
      }
      return { ...state, editOptions };
    }
    case 'UPDATE_TAGS_SELECT_TAB': {
      const selectedTab = action.tab;
      return { ...state, selectedTab };
    }
    case 'UPDATE_TAGS_CHECK_CHECKBOX': {
      const clearCheckbox = { ...state.clearCheckbox };
      const { checkFreeTag, checkMasterTag } = action;
      if (checkFreeTag !== undefined) {
        clearCheckbox.freeTag = checkFreeTag;
      }
      if (checkMasterTag !== undefined) {
        clearCheckbox.masterTag = checkMasterTag;
      }
      return { ...state, clearCheckbox };
    }
    case Type.SUCCESS_API_DOWNLOAD_MEDIA_FILES: {
      return { ...state, checkbox: appInitialState.checkbox };
    }
    case 'SUCCESS_API_GET_ALL_TAGS': {
      const tagsForSearch = action.payload.tags || [];
      const flatTags = getFlatTags(tagsForSearch);
      return { ...state, flatTags, tagsForSearch };
    }
    case 'CLOSE_TIMELINE_TAG_SEARCH_DIALOG': {
      const { flatTags, tagsForSearch } = appInitialState;
      return { ...state, flatTags, tagsForSearch };
    }
    case 'CHANGE_DISPLAY_TAG': {
      const { displayTag } = action && action.params;
      let isDeleted = null;
      switch (displayTag) {
        case config.DISPLAY_TAG.use:
          isDeleted = false;
          break;
        case config.DISPLAY_TAG.delete:
          isDeleted = true;
          break;
        default:
          break;
      }
      const searchOptions = { ...state.searchOptions, isDeleted };
      return { ...state, searchOptions };
    }
    case Type.SUCCESS_API_WORK_RECORD_URLS: {
      return { ...state, checkbox: appInitialState.checkbox };
    }
    default:
      return state;
  }
};
